import { Schema } from 'normalizr';

export const attachmentSchema = new Schema('attachment', { idAttribute: 'id' });
